import React from "react";
import { ExportType } from "../../../../lib-api";
import { CustomDataGridHeader } from "../../../shared/datagrid/CustomDataGridHeader";

export const ExportLeasingDataToolbar: React.FunctionComponent<{
  uploadVins: (
    vins: string[],
    exportType: ExportType,
    projectFolderId?: string | undefined,
    name?: string | undefined
  ) => Promise<void>;
}> = (props) => {
  return (
    <CustomDataGridHeader
      headerProps={{
        displayHeadline: "Leasing lookup",
        filters: [
          {
            type: "submitmultiplewithprojects",
            loadingText: "Adding VINs..",
            name: "Upload multiple VINs",
            placeholder: "Name of data",
            onSubmitVehicleId: (ids, projectId, name) => {
              props.uploadVins(
                ids,
                ExportType.LeasingData,
                projectId == "-1" ? undefined : projectId,
                name
              );
            },
            position: "right",
          },
        ],
        isTab: true,
      }}
    ></CustomDataGridHeader>
  );
};
